import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef, NgbModalOptions, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiRequestModel } from '../../../../../../src/app/ncs/models/api_request_model';
import { DoctorAppointmentsByDoctorcode2Contoller, DoctorsListController, DoctorsListRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { DoctorAppointmentsByDoctorCode2Request } from '../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';



@Component({
  selector: 'sp_doctorappointments',
  templateUrl: './sp_doctorappointments.component.html',
  styleUrls: ['./sp_doctorappointments.component.scss']
  //styleUrls: ['./rncloudstartup.component.scss']
})

export class SmartPhoneDocAppointmentsComponent implements OnInit {


  public ApiReqData: ApiRequestModel;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public DisplayPresentDate: boolean = true;
  public DisplaySelectedDate: boolean = false;
  public DisplayChangedDate: boolean = false;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  public PresentDate: Date;
  public DateSelected: Date;
  public ChangedDate: Date;
  public SelectedDatenew: Date;
  public ProviderCode: number;
  SelectedFacilityCode: number;
  public BranchName: string;
  TodayDate = new Date();
  CurrentDoctorsListController: DoctorsListController[];
  CurrentDoctorsListRequest: DoctorsListRequest;
  selectedDoc: DoctorsListController;
  doctors: any[];
  LoadDoctorsList() {
    this.CurrentDoctorsListController = new Array<DoctorsListController>();

    this.CurrentDoctorsListRequest = new DoctorsListRequest();
    this.doctors = this.CurrentDoctorsListController;

 
   this.CurrentDoctorsListRequest.ConditionalOperator = 20

    this.CurrentDoctorsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentDoctorsListRequest.ProvidersSpecality = "";
    this.CurrentDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorsListController();
  }
  GetDoctorsListController() {
    this.StartRefreshing();

    this.actorservice.GetDoctorsListController(this.CurrentDoctorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentDoctorsListController = this.ApiResData.Result;
          this.doctors = this.CurrentDoctorsListController;
          //alert(this.CurrentServiceCategoriesController.length);
         
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private actorservice: ActorService,
    private parserFormatter: NgbDateParserFormatter,
    private loaderService: SpinnerService,
  ) { }
  ngOnInit() {
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.PresentDate = new Date();
    this.ProviderCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.SelectedFacilityCode = AppData.Instance().SelectedBranchCode;
    this.BranchName = AppData.Instance().SelectedBranchName;
   // this.LoadDoctorAppointmentsByDoctor();
    this.CurrentDoctorAppointmentsByDoctorcodeController = new Array<DoctorAppointmentsByDoctorcode2Contoller>();

    this.CurrentDoctorAppointmentsByDoctorCodeRequest = new DoctorAppointmentsByDoctorCode2Request();
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 16;
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.LoadDoctorsList();
   // this._GetDoctorAppointmentsByDoctorcodeContoller();
    //alert(this.DateSelected);
  }
  onDocChange(event: any) {
    //alert(event);
    if (event != null) {
      this.ProviderCode = event;
      //var e = event as DoctorsListController;
      //this.selectedDoc = e;
      //alert(this.selectedDoc.DisplayName);
      //this.ProviderCode = e.ProviderCode;
      //alert(this.ProviderCode);
      this._GetDoctorAppointmentsByDoctorcodeContoller();

    }

  }
  //SelectedFacilityCode: number;
  SelectedFacilityName: string;
  Roleassign(event: any) {
  //  alert(event);
    if (event != null) {


      this.SelectedFacilityName = event;
      this.BranchName = this.SelectedFacilityName;
    //  alert(this.SelectedFacilityName );
      if (this.data == null) {

        this._GetDoctorAppointmentsByDoctorcodeContoller();

      }
      else {

        this.CurrentDoctorAppointmentsByDoctorcodeController =
          this.data.filter(function (v, i, d) {
            //   alert(this.SelectedFacilityCode);
            return v.FacilityName == this.SelectedFacilityName;
          });
      }
    //  this.LoadDoctorAppointmentsByDoctor();
    //  this.LoadDoctorsList(this.SelectedFacilityCode);
    }

  }
  CurrentDoctorAppointmentsByDoctorcodeController: DoctorAppointmentsByDoctorcode2Contoller[];
  CurrentDoctorAppointmentsByDoctorCodeRequest: DoctorAppointmentsByDoctorCode2Request;
  LoadDoctorAppointmentsByDoctor() {
    this.CurrentDoctorAppointmentsByDoctorcodeController = new Array<DoctorAppointmentsByDoctorcode2Contoller>();

    this.CurrentDoctorAppointmentsByDoctorCodeRequest = new DoctorAppointmentsByDoctorCode2Request();
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 15;
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.ChangedDate = this.CurrentDoctorAppointmentsByDoctorCodeRequest.FromDate;
    this.DateSelected = this.CurrentDoctorAppointmentsByDoctorCodeRequest.FromDate;
    this.SelectedDatenew = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date((this.SelectedDatenew).getTime() + (60 * 60 * 24 * 1000));
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel.xLocationCode = this.SelectedFacilityCode;
    //this.CurrentDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    //this.CurrentDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorAppointmentsByDoctorcodeContoller();
  }
  data: DoctorAppointmentsByDoctorcode2Contoller[];
  GetDoctorAppointmentsByDoctorcodeContoller() {

    this.CurrentDoctorAppointmentsByDoctorCodeRequest.ProviderCode = this.ProviderCode;
    // this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = "";
    this.actorservice.GetDoctorAppointmentsByDoctorcodeContoller2(this.CurrentDoctorAppointmentsByDoctorCodeRequest)
      .subscribe((result) => {
        this.ApiReqData = result;
        if (!this.ApiResData.hasError) {
          this.data = this.ApiResData.Result;
          this.CurrentDoctorAppointmentsByDoctorcodeController = this.data;
            //this.data.filter(function (v, i, d) {
            //  return v.FacilityCode == this.SelectedFacilityCode;
            //});


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  _GetDoctorAppointmentsByDoctorcodeContoller() {

    this.CurrentDoctorAppointmentsByDoctorCodeRequest.ProviderCode = this.ProviderCode;
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 15;
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.ChangedDate = this.CurrentDoctorAppointmentsByDoctorCodeRequest.FromDate;
    this.DateSelected = this.CurrentDoctorAppointmentsByDoctorCodeRequest.FromDate;
    this.SelectedDatenew = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date((this.SelectedDatenew).getTime() + (60 * 60 * 24 * 1000));
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel.xLocationCode = this.SelectedFacilityCode;
    this.actorservice.GetDoctorAppointmentsByDoctorcodeContoller2(this.CurrentDoctorAppointmentsByDoctorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.data = this.ApiResData.Result;
          this.CurrentDoctorAppointmentsByDoctorcodeController = this.data;

            //this.data.filter(function (v, i, d) {
            //  return v.FacilityCode == this.SelectedFacilityCode;
            //});

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  dataChanged(newobj) {
    this.DisplayPresentDate = false;
    this.DisplaySelectedDate = false;
    this.DisplayChangedDate = true;
    this._GetDoctorAppointmentsByDoctorcodeContoller();
  }
  DecrementDate(Value: any) {
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this.DisplayPresentDate = false;
    this.DisplaySelectedDate = true;
    this._GetDoctorAppointmentsByDoctorcodeContoller();

  }
  IncrementDate(Value: any) {
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this.DisplayPresentDate = false;
    this.DisplaySelectedDate = true;
    this._GetDoctorAppointmentsByDoctorcodeContoller();

  }


}
